namespace GeniuzPOS.InitialData {
    export enum CashCouponValueType {
        ValueType = 0,
        ValueType1 = 1
    }
    Serenity.Decorators.registerEnumType(CashCouponValueType, 'GeniuzPOS.InitialData.CashCouponValueType');
}
